module.exports = __webpack_public_path__ + "img/extended.0a84f6ea.png";